import * as React from 'react';
import {
  useSimulateContract,
  useWriteContract,
  useWaitForTransactionReceipt,
} from 'wagmi';
import { multiMint } from '../multiMint.js';

export function Withdraw(props) {
  const {
    data: simData,
    error: prepareError,
    isError: isPrepareError,
  } = useSimulateContract({
    address: multiMint.addr,
    abi: multiMint.abi,
    functionName: 'withdraw',
  });

  const {
    writeContract,
    data: hash,
    error: writeError,
    isError: isWriteError,
    isPending,
  } = useWriteContract();

  const { isLoading, isSuccess } = useWaitForTransactionReceipt({ hash });

  function handleClick() {
    if (!simData?.request) return;
    writeContract(simData.request);
  }

  return (
    <div>
      <div>
        <br></br>
      </div>
      <div>Balance: {props.bal} ETH</div>
      <button
        className='btn btn-primary'
        disabled={!simData?.request || isLoading || isPending}
        onClick={handleClick}
      >
        {isPending
          ? 'Confirm in wallet...'
          : isLoading
          ? 'Withdrawing...'
          : 'Withdraw'}
      </button>
      {isSuccess && (
        <div>
          Successfully withdrew your funds!
          <div>
            <a
              href={`https://etherscan.io/tx/${hash}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              Etherscan
            </a>
          </div>
        </div>
      )}
      {(isPrepareError || isWriteError) && (
        <div style={{ color: '#c33' }}>
          Error:{' '}
          {(prepareError || writeError)?.shortMessage ||
            (prepareError || writeError)?.message}
        </div>
      )}
    </div>
  );
}
